var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"hover"}},[_c('span',[_vm._v(_vm._s(_vm.order))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('h1',[_c('a',{attrs:{"href":_vm.card_url}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('p',[_vm._v("电话： "+_vm._s(_vm.phone))]),_vm._v(" "),_c('p',[_vm._v("地址： "+_vm._s(_vm.address))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ebd1d56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zwfwmap-pc/left_cmpt_demo/list_card.vue
// module id = null
// module chunks = 